import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  getWork,
  getEdu,
  getSkills,
  getUserById,
  getUserQuestionAndAnswer,
} from "../../features/applicantSlice";
import { PuffLoader } from "react-spinners";
import { Button, Col, Row } from "react-bootstrap";
import ReadMore from "../../Components/Elements/ReadMore";
import {
  updateJobSingleStatus,
  updateJobStatus,
} from "../../features/jobSlice";
import { toast } from "react-toastify";

const ApplicantProfile = () => {
  const {
    isLoading,
    experience,
    education,
    allSkills,
    singleApplicant,
    questionAnswer,
  } = useAppSelector((state) => state.applicant);

  const { applicantId } = useParams();
  const userId = applicantId ? Number(applicantId) : 0;

  const { id } = useParams();
  const jobId = id ? Number(id) : 0;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Fetch existing experiences on mount
  useEffect(() => {
    if (userId) {
      dispatch(getUserById(userId));
      dispatch(getWork(userId));
      dispatch(getEdu(userId));
      dispatch(getSkills(userId));
      dispatch(
        getUserQuestionAndAnswer({ job_id: jobId, applicant_id: userId })
      );
    }
  }, [dispatch, userId]);

  const handleBulkUpdate = async (status: string, selectedIds: number) => {
    let data = {
      jobIds: selectedIds,
      user_id: userId,
      jobStatus: status,
    };

    dispatch(updateJobSingleStatus(data))
      .unwrap()
      .then((response: any) => {
        toast.success(`Applicants ${status} successfully`);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  if (isLoading || !singleApplicant || !experience || !education || !allSkills)
    return (
      <div className="flex d-flex justify-content-center align-items-center py-5 mt-5">
        <PuffLoader
          color="#073367"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  console.log(allSkills);
  return (
    <div className="profile">
      <div className="d-flex justify-content-between">
        <h5 className="font-headers">Applicant Profile</h5>
        <Button variant="secondary text-white" className="rounded-0 px-4">
          Go to Interview
        </Button>
      </div>

      <div className="mt-3">
        <h5 className="font-headers text-secondary">Information</h5>
      </div>
      <Row>
        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">First Name</h6>
          <p className="font-bodies-1">{singleApplicant.data.first_name}</p>
        </Col>

        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">Last Name</h6>
          <p className="font-bodies-1">{singleApplicant.data.last_name}</p>
        </Col>
        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">Middle Name</h6>
          <p className="font-bodies-1">{singleApplicant.data.middle_name}</p>
        </Col>

        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">Email</h6>
          <p className="font-bodies-1">{singleApplicant.data.email}</p>
        </Col>

        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">Phone</h6>
          <p className="font-bodies-1">{singleApplicant.data.phone}</p>
        </Col>
        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">Address</h6>
          <p className="font-bodies-1">{singleApplicant.data.address}</p>
        </Col>
        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">Province/State</h6>
          <p className="font-bodies-1">{singleApplicant.data.province}</p>
        </Col>

        <Col md={3} sm={12} className="mt-3">
          <h6 className="font-bodies">City</h6>
          <p className="font-bodies-1">{singleApplicant.data.city}</p>
        </Col>
      </Row>
      <hr className="hr" />

      <div className="mt-3">
        <h5 className="font-headers text-secondary">Work Experience</h5>
      </div>
      {experience &&
        experience.map((exp: any) => (
          <>
            <Row key={exp.id} className="mt-3">
              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">Job Title</h6>
                <p className="font-bodies-1">{exp.job_title}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">Company</h6>
                <p className="font-bodies-1">{exp.company}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">Location</h6>
                <p className="font-bodies-1">{exp.location}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">From</h6>
                <p className="font-bodies-1">{exp.start_date}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">To</h6>
                <p className="font-bodies-1">
                  {exp.working === 1 ? "Currently Working" : exp.end_date}
                </p>
              </Col>

              <Col md={12} sm={12} className="mb-2">
                <h6 className="font-bodies">Job Description</h6>
                <ReadMore text={exp.role || "no description available"} />
              </Col>
            </Row>
            <hr className="hr" />
          </>
        ))}

      <div className="mt-3">
        <h5 className="font-headers text-secondary">Education</h5>
      </div>
      {education &&
        education.map((exp: any) => (
          <>
            <Row key={exp.id} className="mt-3">
              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">School/University</h6>
                <p className="font-bodies-1">{exp.school}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">Degree</h6>
                <p className="font-bodies-1">{exp.degree}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">Course of Study</h6>
                <p className="font-bodies-1">{exp.course}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">OverAll GPA</h6>
                <p className="font-bodies-1">{exp.gpa}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">From</h6>
                <p className="font-bodies-1">{exp.start_date}</p>
              </Col>

              <Col md={4} sm={12} className="mb-2">
                <h6 className="font-bodies">To</h6>
                <p className="font-bodies-1">{exp.end_date}</p>
              </Col>
            </Row>
            <hr className="hr" />
          </>
        ))}
      <div className="mt-3">
        <h5 className="font-headers text-secondary">Resume</h5>
      </div>

      <>
        <Row key={allSkills?.id} className="mt-3">
          <Col md={12} sm={12} className="mb-2">
            <h6 className="font-bodies">Skills</h6>
            <p className="font-bodies-1">
              {Array.isArray(allSkills?.skills)
                ? allSkills.skills.join(", ")
                : allSkills?.skills
                    ?.replace(/[\[\]"]/g, "")
                    .replace(/,/g, ", ")}
            </p>
          </Col>

          <Col md={4} sm={12} className="mb-2">
            <div className="mb-3">
              <h6 className="font-bodies">Resume</h6>
            </div>

            <div>
              <Link to={allSkills.resume_url} target="_blank">
                <i className="bi bi-file-earmark-text-fill fs-1 border p-3 text-muted"></i>
              </Link>
            </div>
          </Col>

          <Col md={4} sm={12} className="mb-2">
            <h6 className="font-bodies">Website</h6>
            <p className="font-bodies-1">{allSkills?.websites}</p>
          </Col>

          <Col md={4} sm={12} className="mb-2">
            <h6 className="font-bodies">Social Network (Linkedin)</h6>
            <p className="font-bodies-1">{allSkills?.linkedin}</p>
          </Col>

          <Col md={12} sm={12} className="mb-2 mt-5">
            <div className="mt-3">
              <h5 className="font-headers text-secondary">
                Application Questions
              </h5>
            </div>
            <>
              {questionAnswer &&
              (questionAnswer.employeeQuestion?.length > 0 ||
                questionAnswer.preQuestion?.length > 0) ? (
                <ol>
                  {questionAnswer.employeeQuestion?.map(
                    (question: any, index: number) => (
                      <div className="mb-3" key={`employee-${index}`}>
                        <li key={`employee-${index}`}>
                          <span>{question.questions}</span>
                          <br />
                          <strong>{question.answers}</strong>
                        </li>
                      </div>
                    )
                  )}

                  {questionAnswer.preQuestion?.map(
                    (question: any, index: number) => (
                      <div className="mb-3" key={`employee-${index}`}>
                        <li key={`pre-${index}`}>
                          <span>{question.jobQuestion}</span>
                          <br />
                          <strong>{question.options}</strong>
                        </li>
                      </div>
                    )
                  )}
                </ol>
              ) : (
                <p>No questions or answers available.</p>
              )}
            </>
          </Col>
        </Row>
        <hr className="hr mb-5" />
        <Button
          variant="secondary"
          size="sm"
          className="me-2 px-3 text-white"
          onClick={() => handleBulkUpdate("shortlisted", jobId)}
        >
          Shortlist Applicant
        </Button>
        <Button variant="secondary" size="sm" className="me-2 px-3 text-white">
          Schedule Interview
        </Button>
        <Button
          variant="danger"
          size="sm"
          className="px-3"
          onClick={() => handleBulkUpdate("reject", jobId)}
        >
          Reject Applicant
        </Button>
      </>
    </div>
  );
};

export default ApplicantProfile;
